import { render, staticRenderFns } from "./host-common-manage.vue?vue&type=template&id=23d44a98&scoped=true&"
import script from "./host-common-manage.vue?vue&type=script&lang=js&"
export * from "./host-common-manage.vue?vue&type=script&lang=js&"
import style0 from "./host-common-manage.vue?vue&type=style&index=0&id=23d44a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d44a98",
  null
  
)

export default component.exports